import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  LOAD_CLIENT_CREDIT_CARDS,
  SEND_LINK_TO_ADD_CARD,
  loadClientCreditCards,
  sendLinkToAddCard
} from 'src/store/actions/clientActions';
import { Tooltip, Button, Box } from '@mui/material';
import { Add } from '@mui/icons-material';
import clsx from 'clsx';
import { selectClientCreditCards } from 'src/store/selectors/clientSelectors';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'src/components/ConfirmDialog/ConfirmationDialog';
import CreditCardsTable from './CreditCardsTable';
import useStyles from '../styles';

const CreditCardsList = ({ client }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id: clientId } = useParams();
  const creditCards = useSelector(selectClientCreditCards);

  const loadingCreditCards = useSelector(
    isLoadingSelector([LOAD_CLIENT_CREDIT_CARDS.action])
  );

  const loadingSendLink = useSelector(
    isLoadingSelector([SEND_LINK_TO_ADD_CARD.action])
  );
  const { classes } = useStyles();

  const [openSendLinkDialog, setOpenSendLinkDialog] = useState(false);

  const handleSendLinkToAddCard = () => {
    setOpenSendLinkDialog(true);
  };

  const handleCloseSendLinkDialog = () => {
    setOpenSendLinkDialog(false);
  };

  const handleConfirmSendLink = useCallback(() => {
    dispatch(sendLinkToAddCard(clientId, handleCloseSendLinkDialog));
  }, [clientId, dispatch]);

  useEffect(() => {
    if (client) dispatch(loadClientCreditCards(clientId));
  }, [client, clientId, dispatch]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Tooltip
        title={t('CLIENTS_VIEW.BILLING_DETAIL.SEND_LINK_TO_ADD_CARD')}
        placement="left"
      >
        <Button
          variant="contained"
          color="secondary"
          className={clsx(classes.buttons, classes.outlined)}
          sx={{ alignSelf: 'flex-end', marginTop: 2 }}
          onClick={handleSendLinkToAddCard}
        >
          <Add className={classes.icon} />
        </Button>
      </Tooltip>

      <ConfirmationDialog
        isLoading={loadingSendLink}
        open={openSendLinkDialog}
        handleClose={handleCloseSendLinkDialog}
        onSubmit={handleConfirmSendLink}
        title={t('CLIENTS_VIEW.BILLING_DETAIL.SEND_LINK_TO_ADD_CARD')}
        description={t(
          'CLIENTS_VIEW.BILLING_DETAIL.SEND_LINK_TO_ADD_CARD_DESCRIPTION'
        )}
      />

      <CreditCardsTable
        loading={loadingCreditCards}
        creditCards={creditCards}
        clientId={clientId}
      />
    </Box>
  );
};

CreditCardsList.propTypes = {
  client: PropTypes.object.isRequired
};

export default CreditCardsList;
